'use strict';

var HeaderView = require('components/dashboard/views/tile_header_view');
var FooterView = require('components/dashboard/views/tile_footer_view');

var TileLayoutView = Marionette.LayoutView.extend({
    template: require('components/dashboard/templates/tile_layout'),
    className: 'tile-content',

    regions: {
        header: '.js-tile-header',
        body: '.js-tile-body',
        footer: '.js-tile-footer',
    },

    childEvents: {
        'footer:action': 'handleFooterAction',
        toggleFullscreen: 'toggleFullscreen',
        'update:footer': 'updateFooter',
        'update:header': 'updateHeader',
    },

    initialize: function (options) {
        this.tile = options.tile;
    },

    onShow: function () {
        var mainView = this.tile.getView(this.options.data, this.options.status);
        if (typeof mainView.getHeaderConfiguration != 'function') {
            // debugger;
        }
        if (mainView.getHeaderConfiguration()) {
            this.showChildView('header', new HeaderView(mainView.getHeaderConfiguration()));
        }
        this.showChildView('body', mainView);
        this.showChildView('footer', new FooterView(mainView.getFooterConfiguration()));
    },

    handleFooterAction: function (_footer, action) {
        this.body.currentView.handleFooterAction(action);
    },

    toggleFullscreen: function () {
        this.triggerMethod('toggle:fullscreen', parseInt(this.tile.definition.region.split('-')[1]));
    },

    updateFooter: function (_view, footerConfiguration) {
        this.showChildView('footer', new FooterView(footerConfiguration));
    },

    updateHeader: function (_view, headerConfiguration) {
        this.showChildView('header', new HeaderView(headerConfiguration));
    },
});

module.exports = TileLayoutView;
